import React, { useState, useEffect } from 'react';
import RadioPlayer from './RadioPlayer';
import './App.css';

function App() {
  const [showCookiePopup, setShowCookiePopup] = useState(false);
  const [showGeoPopup, setShowGeoPopup] = useState(false);
  const [location, setLocation] = useState(null);
  const [browserInfo, setBrowserInfo] = useState('');

  useEffect(() => {
    // Pobranie informacji o przeglądarce
    setBrowserInfo(navigator.userAgent);

    // Sprawdzenie zgody na cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setShowCookiePopup(true);
    } else {
      // Jeśli użytkownik zaakceptował cookies, sprawdzamy geolokalizację
      const geoConsent = localStorage.getItem('geoConsent');
      if (!geoConsent) {
        setShowGeoPopup(true);
      } else {
        fetchLocation();
      }
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    setShowCookiePopup(false);
    setShowGeoPopup(true); // Po cookies pokazujemy popup o geolokalizacji
  };

  const handleAcceptGeo = () => {
    localStorage.setItem('geoConsent', 'true');
    setShowGeoPopup(false);
    fetchLocation();
  };

  const fetchLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation(`Lat: ${latitude}, Lon: ${longitude}`);
        },
        () => {
          setLocation('Nie udało się pobrać lokalizacji.');
        }
      );
    } else {
      setLocation('Geolokalizacja nie jest obsługiwana przez tę przeglądarkę.');
    }
  };

  return (
    <div className="app">
      <header className="header">
        <h1>Radio Internetowe</h1>
      </header>

      <main className="main-content">
        <RadioPlayer />
        {location && <p>📍 Twoja lokalizacja: {location}</p>}
        {browserInfo && <p>🖥 Twoja przeglądarka: {browserInfo}</p>}
      </main>

      <footer className="footer">
        <p>&copy; 2025 Radio Internetowe. Wszelkie prawa zastrzeżone.</p>
      </footer>

      {/* Popup - Zgoda na cookies */}
      {showCookiePopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h2>Polityka Prywatności</h2>
            <p>Nasza strona używa plików cookie do poprawy jakości usług. Czy zgadzasz się na ich używanie?</p>
            <button onClick={handleAcceptCookies}>Akceptuję</button>
          </div>
        </div>
      )}

      {/* Popup - Zgoda na geolokalizację */}
      {showGeoPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h2>Zgoda na geolokalizację</h2>
            <p>Czy zgadzasz się na udostępnienie swojej lokalizacji?</p>
            <button onClick={handleAcceptGeo}>Akceptuję</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
